import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/athlete-proposition-bet.module.scss";
import {AthletePropositionBetModuleOption} from "./athlete-proposition-bet-module.option";
import {useBookieClick} from "../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../core/app/consts";
import {WIDGET_TYPES} from "../../../core/consts";
import {PREDICTION_WIDGET} from "../../../widgets/prediction-widget/predictions-widget.consts";
import {PROPOSITION_BETS} from "../../../widgets/proposition-bets-widget/proposition-bets-widgets.consts";

export const AthletePropositionBetModuleOptions = observer(({controller, row}) => {
  const {state, config} = controller;
  const {source} = config;
  const {bookmaker, game, currentLinkModel} = state;
  const {lineTypeId} = row;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    urlLink: bookmaker?.link,
    hasOdds: !!bookmaker,
    marketType: lineTypeId,
    status: game?.statusGroup,
    widget: APP.ANALYTICS.WIDGET_TYPES[WIDGET_TYPES.athletePropositionBet],
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.tooltip,
    subSource: PREDICTION_WIDGET.TABS_LABEL.props,
    buttonType: PROPOSITION_BETS.ANALYTICS.BOOKIE_BUTTON_TYPE.odds,
    currentLinkModelName: currentLinkModel.name,
    source
  });

  return <div className={classNames(styles.options)}>
    {
      row.options?.map(option => <AthletePropositionBetModuleOption row={row}
                                                                    key={option.name}
                                                                    option={option}
                                                                    controller={controller}
                                                                    bookieHrefModel={bookieHrefModel}
                                                                    onBookieClick={() => onBookieClick()}
      />)
    }
  </div>
});
